import { createContext } from "react";

const usersContext = createContext({
  users: [],
  getUsers: (data) => {},
});

export default usersContext;
